import type { OffersInfo, OutflowOfferProps, OutflowOffers } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import type { Channel } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { take } from 'typed-redux-saga';

export function createOfferProcessor<P extends OutflowOfferProps, O extends string | number | symbol = OutflowOffers>(
    offersInfo: Partial<Record<O, OffersInfo>>
) {
    function* processOutflowOffer(offerKey: O, offerArgs: P, outflowChannel: Channel<boolean>) {
        const isSuccess = yield take(outflowChannel);
        const { check = () => true, offer } = (offersInfo[offerKey] || { check: () => false, offer: null }) as OffersInfo;
        const enabled = yield check(offerArgs);
        if (!!offer && enabled && isSuccess) {
            yield offer(offerArgs);
        } else {
            yield call(outflowChannel.put, true);
        }
    }

    function* processOuflowOfferList(outflowOffers: O[], offerArgs: P, outflowChannel: Channel<boolean>) {
        yield offerArgs.continueOutflow();
        for (const offer of outflowOffers) {
            yield processOutflowOffer(offer, offerArgs, outflowChannel);
        }
        yield offerArgs.cancelOutflow();
    }

    return { processOutflowOffer, processOuflowOfferList } as const;
}
